import axios from 'axios'
import { camelCaseKeysToUnderscore, toCamelCaseObj } from '../utils/toCamelCaseObj'
import API_ENDPOINT from './../constants/ApiEndPoints'

class CampaignService {
    getList = (active, page, itemsPerPage) =>
        new Promise((resolve, reject) => {
            axios
                .get(process.env.MIX_API_URL + API_ENDPOINT.campaign.list, {
                    params: {
                        active: active ? 1 : 0,
                        page: page,
                        items_per_page: itemsPerPage
                    }
                })
                .then(response => {
                    if (response.data) {
                        resolve(toCamelCaseObj(response.data))
                    } else {
                        reject(response.data.error)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })

    get = (campaignId, timeRange) =>
        new Promise((resolve, reject) => {
            axios
                .get(process.env.MIX_API_URL + API_ENDPOINT.campaign.get + campaignId + '?' + (timeRange ? 'timeRange=' + timeRange : ''))
                .then(response => {
                    if (response.data) {
                        resolve(toCamelCaseObj(response.data))
                    } else {
                        reject(response.data.error)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })

    getQuestionPageDetail = async idQuestionPage => {
        const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.getQuestionPage + idQuestionPage)
        return res.data
    }

    getCampaignDetail = async id => {
        try {
            const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.getCampaignDetail + id)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateCampaign = async (campaignId, campaignData) => {
        const { ...another } = campaignData

        const payloadWIllSend = camelCaseKeysToUnderscore(another)

        const body = {
            ...payloadWIllSend
        }

        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateCampaign + campaignId, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    deleteCampaign = async campaignId => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.deleteCampaign + campaignId)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    createQuestionPage = async questionPageData => {
        const payloadWIllSend = camelCaseKeysToUnderscore(questionPageData)

        const body = {
            ...payloadWIllSend
        }

        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.createQuestionPage, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateQuestionPage = async (questionPageId, questionPageData) => {
        // delete unuse properties
        // delete questionPageData.questions;

        const { followRate, questions, imageUrl, imgUrl, questionPageVisitsCount, ...another } = questionPageData

        const payloadWIllSend = camelCaseKeysToUnderscore(another)

        const body = {
            ...payloadWIllSend
        }

        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateQuestionPage + questionPageId, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateQuestionPageOrder = async (questionPageId, data) => {
        const payloadWIllSend = camelCaseKeysToUnderscore(data)

        const body = {
            ...payloadWIllSend
        }

        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateQuestionPageOrder + questionPageId, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateQuestionOrder = async (questionPageId, questions) => {
        const body = {
            questions: questions
        }

        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateQuestionOrder + questionPageId, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }
    deleteQuestionPage = async questionPageId => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.deleteQuestionPage + questionPageId)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    getQuestionDetail = async id => {
        try {
            const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.getQuestionDetail + id)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    createQuestion = async body => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.createQuestion, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateQuestion = async (questionId, body) => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateQuestion + questionId, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    attachQuestion = async body => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.attachQuestion, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    detachQuestion = async body => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.detachQuestion, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    getAllQuestion = async () => {
        try {
            const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.getAllQuestion)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    searchQuestion = async (key = '') => {
        try {
            const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.searchQuestion + key)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    getLeadtypeDetail = async id => {
        try {
            const res = await axios.get(process.env.MIX_API_URL + API_ENDPOINT.campaign.getLeadtypeDetail + id)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateLeadtypeDetail = async (body, id) => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateLeadtypeDetail + id, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    createLeadtypeDetail = async body => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.createLeadtypeDetail, body)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    deleteConversionType = async conversionTypeId => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.deleteConversionType + conversionTypeId)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    createRequirements = async (requirementableType, requirementableId, body) => {
        try {
            const res = await axios.post(
                process.env.MIX_API_URL + API_ENDPOINT.campaign.createRequirements + requirementableType + '/' + requirementableId,
                body
            )
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updatePipe = async (pipeId, pipe) => {
        try {
            const res = await axios.put(process.env.MIX_API_URL + API_ENDPOINT.campaign.updatePipe + pipeId, pipe)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    deletePipe = async pipeId => {
        try {
            const res = await axios.delete(process.env.MIX_API_URL + API_ENDPOINT.campaign.deletePipe + pipeId)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    updateActivePipe = async pipeId => {
        try {
            const res = await axios.post(process.env.MIX_API_URL + API_ENDPOINT.campaign.updateActivePipe + pipeId)
            return res.data
        } catch (error) {
            console.log(error)
        }
    }
}

const campaignService = new CampaignService()

export default campaignService
